import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';


function InternationalYogaDay2025() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        International Yoga Day - June 21, 2025
                                    </h2>

                                    <div class="css-script-ads" >
                                    </div>
                                    <div class="spotlight-group">
                                        <div class="row">
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/1.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/1.jpeg" title="Yoga Day 2025 - Image 1" loading="lazy" alt="Yoga Day 2025 - Image 1" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/2.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/2.jpeg" title="Yoga Day 2025 - Image 2" loading="lazy" alt="Yoga Day 2025 - Image 2" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/3.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/3.jpeg" title="Yoga Day 2025 - Image 3" loading="lazy" alt="Yoga Day 2025 - Image 3" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/4.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/4.jpeg" title="Yoga Day 2025 - Image 4" loading="lazy" alt="Yoga Day 2025 - Image 4" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/5.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/5.jpeg" title="Yoga Day 2025 - Image 5" loading="lazy" alt="Yoga Day 2025 - Image 5" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/6.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/6.jpg" title="Yoga Day 2025 - Image 6" loading="lazy" alt="Yoga Day 2025 - Image 6" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/7.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/yoga-day-2025/7.jpg" title="Yoga Day 2025 - Image 7" loading="lazy" alt="Yoga Day 2025 - Image 7" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default InternationalYogaDay2025
